import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getSupplyBrandQuery = gql`query get_supply_brand{
  supply_brands(where: {status: {_eq: "ACTIVE"}}, order_by: {name: asc}){
    id
    name
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupplyBrandService {

  constructor(private apollo: Apollo) { }

  getSupplyBrand(){
    return this.apollo.use('external').query({
      query: getSupplyBrandQuery
    }).pipe(pluck('data', 'supply_brands'));
  }
}

